export default __webpack_public_path__ + "static/handbook-f4362b4da96866253bb7fb503084d86f.jpg";